import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import logo from './assets/reel-easy-logo.png';


type AreaLink = { name: string; url?: string; note?: string };
type AreaCategory = { icon: string; title: string; items: AreaLink[] };

const areaGuide: AreaCategory[] = [
  {
    icon: '🌊',
    title: 'Waterfront Dining',
    items: [
      { name: "Skogie's Lakefront Restaurant", url: 'https://skogieslakefrontrestaurant.us/', note: 'Closest waterfront spot, great atmosphere' },
      { name: "Pelican Pete's", url: 'https://www.pelicanpetes.com/', note: 'Massive floating restaurant' },
      { name: 'The Twisted Oar', url: 'https://www.thetwistedoar.com/' },
      { name: 'Fish Tales Lake Lanier', url: 'https://www.fishtaleslakelanier.com/' },
      { name: 'Pig Tales Lake Lanier', url: 'https://www.pigtaleslakelanier.com/' },
    ],
  },
  {
    icon: '🍖',
    title: 'Local Favorites',
    items: [
      { name: "Smokin' Mike's Meats", url: 'https://www.smokinmikesmeats.com/', note: 'Closest to the house — do not miss it' },
      { name: 'Bourbon Brothers', url: 'https://www.bourbonbrothersga.com/' },
      { name: 'The Hickory Pig BBQ', url: 'https://www.facebook.com/TheHickoryPigBBQ' },
      { name: "Brookton Catfish School", note: 'Local gem — no website, just go' },
      { name: 'Tomato House Farms', url: 'https://www.facebook.com/TomatoHouseFarms/', note: 'Local goods & southern charm' },
    ],
  },
  {
    icon: '🛒',
    title: 'Groceries',
    items: [
      { name: 'Publix, Kroger & Ingles', note: '10 min drive' },
    ],
  },
  {
    icon: '🥾',
    title: 'Hikes & Waterfalls',
    items: [
      { name: "Dick's Creek Falls", url: 'https://www.dahlonega.org/things-to-do/waterfalls/dicks-creek-falls/', note: 'Fantastic summer swimming hole' },
      { name: 'DeSoto Falls', url: 'https://www.fs.usda.gov/r08/chattahoochee-oconee/recreation/desoto-falls-recreation-area' },
      { name: "Duke's Creek Falls", url: 'https://www.fs.usda.gov/r08/chattahoochee-oconee/recreation/dukes-creek-falls-recreation-area' },
      { name: 'Helton Creek Falls', url: 'https://www.fs.usda.gov/r08/chattahoochee-oconee/recreation/helton-creek-falls' },
      { name: 'Vogel State Park', url: 'http://gastateparks.org/Vogel' },
      { name: 'Amicalola Falls', url: 'https://www.amicalolafallslodge.com/' },
      { name: 'Walden Creek Waterfall' },
      { name: 'Long Creek Falls' },
    ],
  },
  {
    icon: '🛥️',
    title: 'Boat Rentals',
    items: [
      { name: 'Lanier Luxury Boat Rentals', url: 'https://lanierluxuryboatrentals.com/' },
      { name: 'Best in Boating', url: 'https://www.bestinboating.com/boat-rentals/lake-lanier/' },
      { name: 'Lanier Boat Charter', url: 'https://lanierboatcharter.com/' },
      { name: 'Sunrise Cove Marina', url: 'https://sunrisecovemarina.com/' },
    ],
  },
  {
    icon: '🎉',
    title: 'Activities',
    items: [
      { name: 'Amicalola Zipline', url: 'https://www.amicalolazipline.com/', note: 'Level 2 — incredible mountain gap ride' },
      { name: 'Lanier Islands Game Changer', url: 'https://www.lanierislands.com/game-changer' },
      { name: 'Margaritaville at Lanier Islands', url: 'https://www.margaritavilleresorts.com/margaritaville-at-lanier-islands' },
      { name: 'Lanier Ghost Tours', url: 'https://lanierghosttours.com/' },
      { name: 'Consolidated Gold Mine', url: 'http://consolidatedgoldmine.com/' },
      { name: 'Crisson Gold Mine', url: 'http://www.crissongoldmine.com/' },
      { name: 'Dahlonega Gold Museum', url: 'http://gastateparks.org/DahlonegaGoldMuseum' },
    ],
  },
  {
    icon: '🌊',
    title: 'Water Fun',
    items: [
      { name: 'Cool River Tubing & Adventures', url: 'https://www.coolrivertubingandadventures.com/' },
      { name: 'Helen Tubing', url: 'http://www.helentubing.com/' },
      { name: 'Water Park at Helen', url: 'https://www.waterparkathelen.com/' },
      { name: 'Margaritaville Water Park', url: 'https://www.margaritavilleresorts.com/margaritaville-at-lanier-islands/attractions/water-park' },
    ],
  },
  {
    icon: '🍷',
    title: 'Breweries, Wineries & Distilleries',
    items: [
      { name: 'Big Creek Distilling', url: 'http://bigcreekdistilling.com/' },
      { name: 'Cavender Creek Vineyards', url: 'https://cavendercreekvineyards.com/' },
      { name: 'Kaya Vineyards', url: 'https://www.kayavineyards.com/' },
      { name: 'Three Sisters Vineyards', url: 'http://www.threesistersvineyards.com/' },
      { name: 'Limoges Cellars', url: 'https://limogescellars.com/' },
      { name: 'Tesnatee River Winery', url: 'http://tesnateeriver.com/' },
      { name: 'Nofo Brew Co.', url: 'https://www.nofobrew.co/' },
      { name: 'Habersham Winery', url: 'https://www.habershamwinery.com/' },
      { name: 'Creekstone Winery', url: 'http://creekstonewinery.com/' },
    ],
  },
];

const galleryItems: { src: string; alt: string }[] = [
  // Hero/gallery grid first 12 — curated mix of best shots
  { src: require('./airbnb-gallery/dock.avif'), alt: 'Private dock on Lake Lanier at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/back.avif'), alt: 'Rear exterior of Reel Easy Retreat with lakefront access' },
  { src: require('./airbnb-gallery/living-room.jpeg'), alt: 'Bright open living room at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/kitchen-and-dining.avif'), alt: 'Open kitchen and dining area at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/screened-porch.avif'), alt: 'Screened-in balcony porch at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/games.avif'), alt: 'Game room at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/lake.avif'), alt: 'Serene Lake Lanier views from Reel Easy Retreat' },
  { src: require('./airbnb-gallery/firepit.avif'), alt: 'Lakeside fire pit for evening gatherings' },
  { src: require('./airbnb-gallery/master.avif'), alt: 'King master bedroom at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/dining.avif'), alt: 'Grand dining table seats 8+ at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/bar.avif'), alt: 'Bar area in the game room' },
  { src: require('./airbnb-gallery/kayak.avif'), alt: 'Kayaks available for guests on Lake Lanier' },
  // Additional slideshow variety
  { src: require('./airbnb-gallery/dock-2.avif'), alt: 'Dock and open water on Lake Lanier' },
  { src: require('./airbnb-gallery/dock-3.avif'), alt: 'Dock with kayaks ready to launch' },
  { src: require('./airbnb-gallery/dock-4.avif'), alt: 'Sunset view from the private dock' },
  { src: require('./airbnb-gallery/dock-5.avif'), alt: 'Lake Lanier from the private dock' },
  { src: require('./airbnb-gallery/back-2.avif'), alt: 'Backyard and lakefront at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/front.avif'), alt: 'Front exterior of Reel Easy Retreat' },
  { src: require('./airbnb-gallery/front-2.avif'), alt: 'Reel Easy Retreat from the driveway' },
  { src: require('./airbnb-gallery/front-door.avif'), alt: 'Welcoming front entry of Reel Easy Retreat' },
  { src: require('./airbnb-gallery/front-porch.avif'), alt: 'Covered front porch' },
  { src: require('./airbnb-gallery/front-porch-2.avif'), alt: 'Front porch seating area' },
  { src: require('./airbnb-gallery/screened-porch-2.avif'), alt: 'Relaxing on the screened porch' },
  { src: require('./airbnb-gallery/porch.avif'), alt: 'Open deck with outdoor seating' },
  { src: require('./airbnb-gallery/porch-2.avif'), alt: 'Deck overlooking the lake' },
  { src: require('./airbnb-gallery/swing.avif'), alt: 'Lakeside swing at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/outdoor-games.avif'), alt: 'Lawn games and outdoor recreation' },
  { src: require('./airbnb-gallery/outdoor-games-2.avif'), alt: 'Outdoor games area' },
  { src: require('./airbnb-gallery/outdoor-games-3.avif'), alt: 'Yard games at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/outdoor-games-4.webp'), alt: 'Cornhole and lawn games' },
  { src: require('./airbnb-gallery/grate-grill.avif'), alt: 'Outdoor grill for cookouts' },
  { src: require('./airbnb-gallery/kayak-2.avif'), alt: 'Kayaking on Lake Lanier' },
  { src: require('./airbnb-gallery/living-room-2.avif'), alt: 'Living room with fireplace and smart TV' },
  { src: require('./airbnb-gallery/living-room-3.avif'), alt: 'Open-concept living area' },
  { src: require('./airbnb-gallery/living-room-4.avif'), alt: 'Comfortable living room seating' },
  { src: require('./airbnb-gallery/living-room-5.avif'), alt: 'Living room with natural light' },
  { src: require('./airbnb-gallery/living-room-6.avif'), alt: 'Cozy living room at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/fireplace.avif'), alt: 'Wood-burning fireplace in the main living room' },
  { src: require('./airbnb-gallery/reading-nook.avif'), alt: 'Cozy reading nook' },
  { src: require('./airbnb-gallery/reading-nook-2.avif'), alt: 'Reading nook with comfortable seating' },
  { src: require('./airbnb-gallery/stairs-and-entry.avif'), alt: 'Entry foyer and staircase' },
  { src: require('./airbnb-gallery/kitchen.avif'), alt: 'Fully equipped kitchen at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/kitchen-2.avif'), alt: 'Modern kitchen with full appliances' },
  { src: require('./airbnb-gallery/coffee-bar.avif'), alt: 'Dedicated coffee bar station' },
  { src: require('./airbnb-gallery/dining-2.avif'), alt: 'Open dining area at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/dining-3.avif'), alt: 'Dining room with natural light' },
  { src: require('./airbnb-gallery/dining-4.avif'), alt: 'Dining space with lake views' },
  { src: require('./airbnb-gallery/dining-5.avif'), alt: 'Family-style dining at Reel Easy Retreat' },
  { src: require('./airbnb-gallery/master-2.avif'), alt: 'Master bedroom suite' },
  { src: require('./airbnb-gallery/master-3.avif'), alt: 'Spacious master with en-suite bath' },
  { src: require('./airbnb-gallery/basement-master.avif'), alt: 'Basement master suite' },
  { src: require('./airbnb-gallery/basement-master-2.avif'), alt: 'Lower level master bedroom' },
  { src: require('./airbnb-gallery/basement-master-3.avif'), alt: 'Basement bedroom with private access' },
  { src: require('./airbnb-gallery/upstairs-bedroom.avif'), alt: 'Upstairs guest bedroom' },
  { src: require('./airbnb-gallery/upstairs-bedroom-2.avif'), alt: 'Guest bedroom with queen bed' },
  { src: require('./airbnb-gallery/upstairs-dark-bedroom.avif'), alt: 'Cozy upstairs bedroom' },
  { src: require('./airbnb-gallery/first-floor-bedroom.avif'), alt: 'First floor guest bedroom' },
  { src: require('./airbnb-gallery/first-floor-bedroom-2.avif'), alt: 'First floor bedroom' },
  { src: require('./airbnb-gallery/loft.avif'), alt: 'Open loft sleeping area' },
  { src: require('./airbnb-gallery/loft-2.avif'), alt: 'Loft with twin beds' },
  { src: require('./airbnb-gallery/kid-bed.avif'), alt: 'Kid-friendly bunk beds' },
  { src: require('./airbnb-gallery/master-bath.avif'), alt: 'Master bathroom with walk-in shower' },
  { src: require('./airbnb-gallery/upstairs-bath.avif'), alt: 'Upstairs full bathroom' },
  { src: require('./airbnb-gallery/games-2.avif'), alt: 'Foosball and entertainment in the game room' },
  { src: require('./airbnb-gallery/games-3.avif'), alt: 'Game room with multiple activities' },
  { src: require('./airbnb-gallery/games-4.avif'), alt: 'Fully stocked game room' },
  { src: require('./airbnb-gallery/games-5.avif'), alt: 'Game room with seating area' },
  { src: require('./airbnb-gallery/games-6.avif'), alt: 'Game room entertainment hub' },
  { src: require('./airbnb-gallery/exercise.avif'), alt: 'Exercise equipment available' },
  { src: require('./airbnb-gallery/washer-dryer.avif'), alt: 'In-unit washer and dryer' },
];

function shuffle<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const shuffledGallery = shuffle(galleryItems);

function App() {
  const [currentImage, setCurrentImage] = useState(0);
  const [fading, setFading] = useState(false);

  const goToImage = (index: number) => {
    setFading(true);
    setTimeout(() => {
      setCurrentImage(index);
      setFading(false);
    }, 800);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goToImage((currentImage + 1) % shuffledGallery.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [currentImage]);

  return (
    <div className="App">
      <header className="hero">
        <div
          className={`hero-bg ${fading ? 'fading' : ''}`}
          style={{ backgroundImage: `url(${shuffledGallery[currentImage].src})` }}
        />
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="sr-only">Reel Easy Retreat — Luxury Lake Lanier Vacation Rental, Gainesville GA</h1>
          <img src={logo} alt="Reel Easy Retreat" className="hero-logo" />
          <p className="tagline">Your Luxurious Lakeside Escape on Lake Lanier</p>
          <a href="https://www.airbnb.com/rooms/1667638070507956091" target="_blank" rel="noopener noreferrer" className="cta-button cta-button--airbnb">Book on Airbnb</a>
          <div className="hero-socials">
            <a href="https://www.facebook.com/profile.php?id=61588537891254" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hero-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/reeleasyretreat/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hero-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            <Link to="/blog" aria-label="Blog" title="Blog" className="hero-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="2 3 20 17.6" fill="currentColor">
                <path d="M11.25 4.533A9.707 9.707 0 0 0 6 3a9.735 9.735 0 0 0-3.25.555.75.75 0 0 0-.5.707v14.25a.75.75 0 0 0 1 .707A8.237 8.237 0 0 1 6 18.75c1.995 0 3.823.707 5.25 1.886V4.533zM12.75 20.636A8.214 8.214 0 0 1 18 18.75c.966 0 1.89.166 2.75.47a.75.75 0 0 0 1-.708V4.262a.75.75 0 0 0-.5-.707A9.735 9.735 0 0 0 18 3a9.707 9.707 0 0 0-5.25 1.533v16.103z"/>
              </svg>
            </Link>
          </div>
        </div>
        <div className="hero-dots">
          {galleryItems.map((_, i) => (
            <button
              key={i}
              className={`dot ${i === currentImage ? 'active' : ''}`}
              onClick={() => goToImage(i)}
              aria-label={`View image ${i + 1}`}
            />
          ))}
        </div>
      </header>

      <section className="about">
        <div className="container">
          <h2>Experience Lake Lanier Living</h2>
          <p className="lead">
            Discover the ultimate lakeside retreat in North Georgia. Our stunning lake house at
            Lake Lanier offers breathtaking water views, modern amenities, and unforgettable
            experiences for families, groups, and water enthusiasts.
          </p>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2>Property Highlights</h2>
          <div className="features-grid">
            <div className="feature">
              <h3>🛥️ Private Dock &amp; Kayaks</h3>
              <p>Your own private dock on Lake Lanier with kayaks included. Guest boats welcome, and local rental companies will deliver a boat right to your slip.</p>
            </div>
            <div className="feature">
              <h3>📶 Dock WiFi</h3>
              <p>No more fake Zoom backgrounds. High-speed WiFi reaches all the way to the dock — take your meeting lakeside with the real thing behind you.</p>
            </div>
            <div className="feature">
              <h3>🔥 Outdoor Living</h3>
              <p>Screened-in balcony porch, fire pit, and a full outdoor grill setup. Hot tub coming soon. The outdoors here are just as comfortable as the indoors.</p>
            </div>
            <div className="feature">
              <h3>🎮 Game Room</h3>
              <p>Fully equipped game room for rainy days, late nights, and friendly competition — the fun doesn't stop when you step off the water.</p>
            </div>
            <div className="feature">
              <h3>🏠 Room for Everyone</h3>
              <p>4 bedrooms, finished basement, 7 beds, and 3 full baths — sleeps a full group comfortably. 3 smart TVs, ample parking, and trailer-friendly driveway.</p>
            </div>
            <div className="feature">
              <h3>🌊 The Quiet Side of the Lake</h3>
              <p>On Lake Lanier's peaceful north shore — far from the crowded, congested south side. Serene water, light boat traffic, and room to actually relax.</p>
            </div>
            <div className="feature">
              <h3>🏔️ Adventure at Your Doorstep</h3>
              <p>Amicalola Falls, the Appalachian Trail, and Helen, GA — with tubing, waterfall hikes, and German-inspired dining — all within easy reach.</p>
            </div>
            <div className="feature">
              <h3>🍽️ Dining, Events &amp; Seasons</h3>
              <p>Waterfront restaurants nearby, 4th of July fireworks over the lake, fall foliage in late October, and Margaritaville on the south side for a day trip.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="gallery-section">
        <div className="container">
          <h2>The Property</h2>
          <div className="gallery-grid">
            {shuffledGallery.slice(0, 12).map((item, i) => (
              <div key={i} className="gallery-item">
                <img src={item.src} alt={item.alt} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="location">
        <div className="container">
          <h2>Location</h2>
          <p>Between Dawsonvillea and Gainesville on Lake Lanier</p>
          <p className="location-details">
            Nestled on the shores of Lake Lanier, Georgia's premier recreational lake,
            our property offers the perfect blend of relaxation and adventure. Just a short
            drive from Atlanta, you'll find yourself in a tranquil paradise.
          </p>
        </div>
      </section>

      <section className="explore">
        <div className="container">
          <h2>Explore the Area</h2>
          <p className="explore-intro">Reel Easy Retreat puts you in the middle of some of North Georgia's best — here's a curated guide to make the most of your stay.</p>
          <div className="explore-grid">
            {areaGuide.map((category) => (
              <div key={category.title} className="explore-category">
                <h3>{category.icon} {category.title}</h3>
                <ul>
                  {category.items.map((item) => (
                    <li key={item.name}>
                      {item.url ? (
                        <a href={item.url} target="_blank" rel="noopener noreferrer">{item.name}</a>
                      ) : (
                        <span>{item.name}</span>
                      )}
                      {item.note && <span className="explore-note"> — {item.note}</span>}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="book" id="book">
        <div className="container">
          <h2>Check Availability &amp; Book</h2>
          <p className="book-sub">Choose your preferred platform to check dates and reserve your stay.</p>
          <div className="book-buttons">
            <a
              href="https://www.airbnb.com/rooms/1667638070507956091"
              target="_blank"
              rel="noopener noreferrer"
              className="book-btn book-btn--airbnb"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12C24 5.372 18.627 0 12 0zm-.007 4.24c.61 0 1.105.498 1.105 1.112 0 .613-.495 1.11-1.105 1.11-.611 0-1.105-.497-1.105-1.11 0-.614.494-1.112 1.105-1.112zM14.92 18.93c-.833.35-1.49.55-2.07.55-1.17 0-1.807-.687-1.807-2.02 0-.376.06-.78.183-1.21l.73-2.44c.065-.22.12-.428.12-.614 0-.333-.13-.502-.39-.502-.188 0-.38.063-.574.19l-.232-.6c.682-.558 1.335-.837 1.956-.837.958 0 1.483.537 1.483 1.554 0 .198-.033.43-.098.697l-.728 2.572c-.076.267-.114.506-.114.717 0 .344.152.516.455.516.183 0 .397-.065.64-.194l.236.621z"/>
              </svg>
              Book on Airbnb
            </a>
            <a
              href="https://wateroakrentals.holidayfuture.com/listings/511011"
              target="_blank"
              rel="noopener noreferrer"
              className="book-btn book-btn--wateroak"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              Book via Water Oak Rentals
            </a>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <img src={logo} alt="Reel Easy Retreat" className="footer-logo" />
          <div className="social-links">
            <a
              href="https://www.facebook.com/profile.php?id=61588537891254"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Reel Easy Retreat on Facebook"
              className="social-link"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a
              href="https://www.instagram.com/reeleasyretreat/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Reel Easy Retreat on Instagram"
              className="social-link"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            <Link
              to="/blog"
              aria-label="Reel Easy Retreat blog"
              title="Blog"
              className="social-link"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="2 3 20 17.6" fill="currentColor">
                <path d="M11.25 4.533A9.707 9.707 0 0 0 6 3a9.735 9.735 0 0 0-3.25.555.75.75 0 0 0-.5.707v14.25a.75.75 0 0 0 1 .707A8.237 8.237 0 0 1 6 18.75c1.995 0 3.823.707 5.25 1.886V4.533zM12.75 20.636A8.214 8.214 0 0 1 18 18.75c.966 0 1.89.166 2.75.47a.75.75 0 0 0 1-.708V4.262a.75.75 0 0 0-.5-.707A9.735 9.735 0 0 0 18 3a9.707 9.707 0 0 0-5.25 1.533v16.103z"/>
              </svg>
            </Link>
          </div>
          <p>&copy; {new Date().getFullYear()} Reel Easy Retreat. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
